<app-toast (onClose)="onClose($event.message)" [baseZIndex]="5000" class="toast-container" position="top-right">
  <ng-template let-message pTemplate="message" class="toast-container__message">
    <div class="toast-message">
      <div>
        <h3 *ngIf="message.summary">{{ message.summary }}</h3>
        <myc-markdown *ngIf="message.detail" [markdown]="message.detail" appExternalLinks></myc-markdown>
      </div>
      <div *ngIf="isToastData(message.data)">
        <div *ngIf="message.data.buttons" class="p-grid toast-message__button-container">
          <div *ngFor="let button of message.data.buttons" class="p-col">
            <button
              (click)="onToastButtonClick($event, button.action)"
              [className]="button.className"
              [icon]="button.icon"
              [label]="button.label"
              pButton
            ></button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</app-toast>
